import React from "react";
import logo from "../images/logo_dark.png";

const SpeakerRegistration = ({
  email,
  setEmail,
  emailError,
  setEmailError,
  city,
  setCity,
  cityError,
  setCityError,
  handleStartSession,
  isStarting,
}) => {
  return (
    <div className="min-h-screen p-5">
      {/* Header */}
      <div className="text-center my-6">
        <div className="flex justify-center mb-10">
          <img
            src={logo}
            alt="Orevan Logo"
            className="w-[44vw] md:w-[30vw] lg:w-[15vw]"
            onError={(e) => (e.target.style.display = "none")}
          />
        </div>

        <h1 className="text-2xl pb-5 font-bold">🎤 Speaker Registration</h1>
        <p className="text-lg">
          Please provide your details to start the presentation
        </p>
      </div>

      {/* Form */}
      <form
        onSubmit={handleStartSession}
        className="bg-white p-8 rounded-xl shadow-lg md:w-[90vw] lg:w-[60vw] mx-auto grid grid-cols-1 gap-6"
      >
        {/* Email */}
        <div className="flex flex-col space-y-4">
          <label htmlFor="email">
            Email Address <span className="text-red-500 font-bold">*</span>
          </label>

          <input
            type="text"
            id="email"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              setEmailError("");
            }}
            className={`w-full p-3 border rounded-lg ${
              emailError ? "border-red-500" : ""
            }`}
            placeholder="Enter your email address"
          />

          {emailError && (
            <span className="text-red-500 text-sm">{emailError}</span>
          )}
        </div>

        {/* City */}
        <div className="flex flex-col space-y-4">
          <label htmlFor="city">
            City <span className="text-red-500 font-bold">*</span>
          </label>

          <input
            type="text"
            id="city"
            value={city}
            onChange={(e) => {
              setCity(e.target.value);
              setCityError("");
            }}
            className={`w-full p-3 border rounded-lg ${
              cityError ? "border-red-500" : ""
            }`}
            placeholder="Enter your city"
          />

          {cityError && (
            <span className="text-red-500 text-sm">{cityError}</span>
          )}
        </div>

        {/* Submit */}
        <button
          type="submit"
          disabled={isStarting}
          className="bg-lightPurple text-white py-3 rounded-lg font-semibold hover:bg-purpleColor transition-colors disabled:opacity-50"
        >
          {isStarting ? "Starting..." : "Start Presentation"}
        </button>
      </form>

      {/* Footer */}
      <div className="p-6 font-semibold mx-auto mt-3 text-center text-gray-400">
        <p>
          As a speaker, you'll have full control over the presentation flow and
          can view real-time results.
        </p>

        <p className="mt-3 text-sm">
          This material is intended to be read/used by healthcare professional,
          and not for distribution amongst general public
        </p>

        <p className="text-sm my-3">
          Breastfeeding is the best source of infant nutrition. Good maternal
          nutrition is important for preparation and maintenance of
          breastfeeding. When infant formula is to be used, a mother should be
          aware of the financial and social implications of formula feeding,
          the difficulty of reversing the decision not to breastfeed, and the
          care that must be taken to prevent partial formula feeding from
          interfering with lactation. Proper preparation of powder or
          concentrated liquid infant formula also requires the use of boiled
          water to mix the formula and clean implements as well as careful
          adherence to mixing instructions. Improper mixing or preparation may
          make the baby sick. A health care professional should be consulted
          before initiating formula feeding.
        </p>

        <p className="text-sm">ANIEMEA-P-SA-202600087</p>
      </div>
    </div>
  );
};

export default SpeakerRegistration;